import '../common';
import React from 'react';
import ReactDom from 'react-dom';
import ContactForm from './components/ContactForm';
import {FluxibleComponent} from "fluxible-addons-react";
import Fluxible from "fluxible";
import batchedUpdatePlugin from "fluxible-addons-react/batchedUpdatePlugin";
import ContactMeStore from "./stores/ContactMeStore";
import Container from "./components/Container";

const app = new Fluxible({ component: Container });
app.plug(batchedUpdatePlugin());
app.registerStore(ContactMeStore);

function render(nodeId, currentLead, guideType, guideDelivery) {
  const mountNode = document.getElementById(nodeId);
  const { contactMe, appointmentSettings } = window.ignite;

  let schema, contactFields;
  if (contactMe) {
    contactFields = contactMe.fields;
    schema = contactMe.schema;
  } else {
    if (guideType === 'business') {
      schema = ContactForm.defaultBusinessSchema;
      contactFields = ContactForm.defaultBusinessFields;
    } else {
      schema = ContactForm.defaultConsumerSchema;
      contactFields = ContactForm.defaultConsumerFields;
    }
    if (guideDelivery === 'branch') {
      contactFields = contactFields.concat(['customerId']);
    }
  }

  let useAppointmentFlow = false;
  if(appointmentSettings){
    useAppointmentFlow = true;
  }

  app.rehydrate({}, (err, context) => {
    function doRender() {
      ReactDom.render(
        React.createElement(
          FluxibleComponent,
          {
            context: context.getComponentContext()
          },
          <Container
            contactLead={currentLead}
            contactFields={contactFields}
            contactSchema={schema}
            useAppointmentFlow={useAppointmentFlow}
          />
        ),
        mountNode
      );
    }

    doRender();
  });
}

function renderContactForm (contactFormId, currentLead, guideType, guideDelivery) {
  render(contactFormId, currentLead, guideType, guideDelivery);
}

function unmountContactForm(contactFormId) {
  ReactDom.unmountComponentAtNode(document.getElementById(contactFormId));
}

if (window.ignite) {
  window.ignite.renderContactForm = renderContactForm;

  window.ignite.unmountContactForm = unmountContactForm;
}

export {
  renderContactForm,
  unmountContactForm
};



/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/index.js
 **/